import { Component, Input } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { BoxGroupInfos } from 'src/app/models/box-group-infos';
import { BoxSelectionEvent } from 'src/app/models/events/box-selection-event';
import { BoxesStateService } from 'src/app/services/state/boxes-state.service';
import { BoxComponent } from '../box/box.component';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-boxes-group',
    templateUrl: './boxes-group.component.html',
    styleUrls: ['./boxes-group.component.scss'],
    imports: [MatCheckboxModule, FormsModule, BoxComponent]
})
export class BoxesGroupComponent {
    /**
     * Informations sur le groupe de bannettes affiché.
     */
    @Input()
    datasource: BoxGroupInfos;

    @Input()
    indeterminate: boolean;

    /**
     * Valeur indiquant si le composant doit émettre des événements. False : n'émet pas d'événement.
     */
    @Input()
    quiet: boolean;

    /**
     * Constructeur.
     * @param boxesStateService
     */
    constructor(private boxesStateService: BoxesStateService) {}

    /**
     * Levé lorsque l'utilisateur coche ou décoche ce groupe de bannette.
     * @param event : Événement coché ou décoché.
     */
    public onChanged(event: MatCheckboxChange) {
        this.datasource.boxes.forEach((b) => (b.selected = event.checked));

        if (!this.quiet) {
            this.boxesStateService.updateBoxesSelectionState(this.datasource.boxes);
        }
    }

    /**
     * Levé lorsque l'utilisateur sélectionne ou déselectionne une bannette.
     * @param evt : Événement de selection de la bannette.
     */
    public onBoxSelected(evt: BoxSelectionEvent) {
        let updatedBox = this.datasource.boxes.find((x) => x.id === evt.boxId);
        updatedBox.selected = evt.selected;
        this.processGroupBoxSelectionState();

        if (!this.quiet) {
            this.boxesStateService.updateBoxesSelectionState([updatedBox]);
        }
    }

    /**
     * Détermine l'état de sélection du groupe de bannette
     */
    private processGroupBoxSelectionState(): void {
        const selectedBoxesCount = this.datasource.boxes.filter((x) => x.selected === true).length;
        if (selectedBoxesCount === 0) {
            this.datasource.selected = false;
            this.indeterminate = false;
        } else if (selectedBoxesCount === this.datasource.boxes.length) {
            this.datasource.selected = true;
            this.indeterminate = false;
        } else {
            this.datasource.selected = false;
            this.indeterminate = true;
        }
    }
}
